import { IframeMessengerable } from '../IframeMessengerPlayerAbstract';
import { Deferred } from '../../Utility/Deferred';
import {
    ApplicationState,
    ApplicationStateInterface,
} from '../interfaces/ApplicationStateInterface';
import PlayerData from '../enums/PlayerData';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function ApplicationStateQueryable<TBase extends IframeMessengerable>(Base: TBase) {
    return class ApplicationStateQueryable extends Base implements ApplicationStateInterface {
        /**
         * Gets current application state
         */
        getApplicationState<T extends ApplicationState>(): Deferred<T> {
            return this._getData(PlayerData.APPLICATION_STATE);
        }
    };
}
